module.exports = __webpack_public_path__ + "static/img/3areaB_2.07aaa11.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/3areaB_2.png
// module id = 1171
// module chunks = 1